export interface OfficeLocation {
  city: string
  region?: string
  country: string
  /** Full street address when available */
  address?: string
  mapsUrl?: string
  isHeadquarters?: boolean
}

export const OFFICE_LOCATIONS: OfficeLocation[] = [
  { city: 'San Francisco', region: 'CA', country: 'US' },
  { city: 'New York', region: 'NY', country: 'US' },
  { city: 'Toronto', region: 'ON', country: 'CA' },
  {
    city: 'Buffalo',
    region: 'NY',
    country: 'US',
    address: '370 Franklin Street, Buffalo, NY 14202',
    mapsUrl: 'https://maps.google.com/?q=370+Franklin+Street+Buffalo+NY+14202',
    isHeadquarters: true,
  },
]

export const OFFICE_LOCATIONS_LABEL = OFFICE_LOCATIONS.map((office) => office.city).join(' · ')

export const OFFICE_LOCATIONS_TAGLINE = `${OFFICE_LOCATIONS_LABEL}`
